import { HttpClient } from '@angular/common/http'

import { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import { Observable } from 'rxjs'

export class TranslateBrowserLoader implements TranslateLoader {
  http: HttpClient
  prefix: string
  suffix: string

  constructor(http: HttpClient, prefix: string, suffix: string) {
    this.http = http
    this.prefix = prefix
    this.suffix = suffix
  }

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`${this.prefix}${lang}${this.suffix}`)
  }
}
